import request from "request-promise-native";

/*
    Makes a POST request to the given URL, including the CSRF token
    scraped from the page's meta tags.
*/
async function postWithCSRF(url, data) {
  var csrfToken;
  var metaTag = document.querySelector("meta[name=csrf-token]");
  if (metaTag) {
    csrfToken = metaTag.content;
  }

  var response = await request(url, {
    method: "POST",
    headers: { "X-CSRF-Token": csrfToken },
    json: data
  });

  return response;
}

/*
  Makes a GET request to the given URL, including a token authorization
  header.
*/
async function getWithToken(url, token) {
  var response = await request(url, {
    method: "GET",
    headers: { Authorization: token },
    json: true
  });

  return response;
}

/*
  Makes a POST request to the given URL, including a token authorization
  header.
*/
async function postWithToken(url, data, token) {
  var response = await request({
    method: "POST",
    uri: url,
    headers: { Authorization: token },
    body: data,
    json: true
  });

  return response;
}

export { postWithCSRF, getWithToken, postWithToken };
